// Owner: tenant-connect (owner feedback F18). Account › Connections: your mailbox and calendar.
import { createFileRoute } from '@tanstack/react-router';
import { MyConnectionsPage } from '../../../features/tenant-connect/MyConnectionsPage';

export const Route = createFileRoute('/_settings/account/connections')({
  component: MyConnectionsPage,
});
